module.exports = __webpack_public_path__ + "static/media/redes04.847ff051.svg";